const ENTER = 'Enter'
const SPACE = ' '

/**
 *
 * @param keydownData an object containing the following optional properties:
 * - cb: a callback function
 *  - When no callback is defined, the default behavior is to click the target element
 *    that caused the keyboard event to fire.
 * - keyCodes: the keyboard keys to trigger the callback, defaulted to the Enter and Space keys
 *
 * @param e the keyboard event containing the keyboard key that was pressed
 */
export const watchKeyboardBtnPress =
  ({ keyCodes = [ENTER, SPACE], cb } = {}) =>
  (e) => {
    if (!keyCodes.includes(e.key)) {
      return
    }
    
    e.preventDefault()
    
    if (cb) {
      cb(e)
    } else {
      e.currentTarget.click()
    }
  }